<template>
    <div class="all">
        <!-- 会员导航 -->
        <vipMenu></vipMenu>
        <div class="warp mt20">
            <div class="warp-body">
                <div class="vip-warp">
                    <div class="vip-rank fl clearfix ac" :class="vipIcons[memberType].bg" v-if="memberType != 0 && memberType < 5">
                        <i class="icons" :class="vipIcons[memberType].icon"></i>
                        {{memberTypeName}}
                    </div>
                     <div class="vip-rank fl clearfix ac" :class="vipIcons[1].bg" v-else-if="memberType > 4 && memberType != 0">
                        <i class="icons" :class="vipIcons[1].icon"></i>
                        {{memberTypeName}}
                    </div>
                    <div class="vip-rank fl clearfix ac" :class="vipIcons[memberType].bg" v-if="memberType === 0">
                        <span class="text db">试用期剩余</br>{{remainDays}}天</span>
                    </div>
                    <div class="vip-caozuo">
                        <div class="text fl">
                            开通清博会员，更多权益任性用
                        </div>
                        <div class="caozuo clearfix fr" v-if="$parent.isMajorAccount === 2">
                            <!-- <span class="ge fl">
                                <i class="icons vip-icon"></i>
                                <button class="btn btn-jbblue" @click="renesJump();">{{memberType === 0 ? '开通会员' : '续费会员'}}</button>
                            </span>
                            <span class="ge fl">
                                <i class="icons dx-icon"></i>
                                <button class="btn btn-jborange" @click="duanXinJump();">充值短信</button>
                            </span>
                            <span class="ge fl">
                                <i class="icons download-big-icon"></i>
                                <button class="btn btn-jborange" @click="downloadJump();">充值下载量</button>
                            </span> -->
                            <span class="ge fl" v-for="(item,index) in memberRechargeIcon" :key="index">
                                <!-- <i class="icons" :class="item.icon"></i> -->
                                <button v-if="item.id == 'memberRenew'||item.id == 'memberBuy'" class="btn" :class="item.class" @click="renesJump();">{{item.name}}</button>
                                <button v-else-if="item.id == 'messageRecharge'" class="btn" :class="item.class" @click="duanXinJump();">{{item.name}}</button>
                                <button v-else-if="item.id == 'downloadBuy'" class="btn" :class="item.class" @click="downloadJump();">{{item.name}}</button>
                                <button v-else class="btn" :class="item.class" @click="huDongJump();">{{item.name}}</button>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="quanyi-table mt20" v-if="$parent.isMajorAccount === 2">
                    <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                        <colgroup>
                            <col width="33%">
                            <col width="33%">
                            <col width="33%">
                        </colgroup>
                        <tbody>
                            <tr v-for="(item,index) in memberRights" :key="index">
                                <td v-for="(i,j) in item" :key="j"><i class="icons right-icon"></i>{{i}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import {mapState} from 'vuex';
import vipMenu from './vipMenu.vue';
export default {
    components:{vipMenu},
    computed:{
        ...mapState({
            memberRechargeIcon: state => state.show.memberRechargeIcon
        })
    },
    data() {
        return {
            vipIcons:[
                {'icon':'','bg':'vip-rank2'},
                {'icon':'rank-icon4','bg':'vip-rank4'},
                {'icon':'rank-icon1','bg':'vip-rank1'},
                {'icon':'rank-icon3','bg':'vip-rank3'},
                {'icon':'rank-icon5','bg':'vip-rank5'}
            ],//会员等级对照表
            memberTypeName:'',//会员名称
            remainDays:'',//会员剩余天数
            memberType:'',//会员等级
            memberRights:''//会员权限
        }
    },
    mounted() {
        setTimeout(()=>{
            let kf = document.querySelector('#icon_module')
            kf.style.display = 'block'
        },500)
		let that = this;
        that.$nextTick(()=> {
            that.getPageInformation();
        }) 
    },
    created() {
		
    },
    beforeRouteLeave(to, from, next) {
        let kf = document.querySelector('#icon_module')
        kf.style.display = 'none'
        next()
    },
    methods: {
        // 获取页面信息
        getPageInformation () {
            let that = this;
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('user/member/member-rights',null,r =>{
                that.$parent.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    let data = r.data;
                    that.memberTypeName = data.memberGradeName;
                    that.memberType = data.memberGrade;
                    let memberRights = [];
                    // let arr = [];
                    // for(let i in data.memberRights){
                    //     if(i%3 === 0 && i != 0){
                    //         memberRights.push(arr);
                    //         arr = [];   
                    //     }
                    //     arr.push(data.memberRights[i]);
                    // }
                    for(let i=0,len=data.memberRights.length;i<len;i+=3){
                        memberRights.push(data.memberRights.slice(i,i+3));
                    }
                    that.remainDays = data.remainDays;
                    that.memberRights = memberRights;
                });
            })
        },
		// 会员购买
        renesJump () {
            if(this.memberType === 0){
                this.$router.push({ path:''+this.$parent.baseUrl+'/vipBuy'})   
            }else{  
                this.$router.push({ path:''+this.$parent.baseUrl+'/renew',query:{memberType:this.memberType,form:'renew'}})
            }
        },
		// 短信购买
        duanXinJump () {
            this.$router.push({ path:''+this.$parent.baseUrl+'/duanXinRecharge'})
        },
		// 下载量购买
        downloadJump () {
            this.$router.push({ path:''+this.$parent.baseUrl+'/downloadBuy'})
        },
        //互动量购买
        huDongJump () {
            if(this.$store.state.show.configInfo.commentUpdate == 1){
                this.$router.push({ path:''+this.$parent.baseUrl+'/weiboHudong'})
            }else{
                this.$utils.alertText('尊敬的用户您好，您当前无充值互动量权限，如需更多权益，请拨打客服电话400-6565-919进行业务办理。',3000);
            }   
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/vipRight.vue